/* eslint-disable */
import React from 'react'
import { scaleLinear } from 'd3-scale'
import { line } from 'd3-shape'
import CalculateHitLocation from '../../Utilities/CalculateHitLocation'

export default function FieldDegreeMarkers({ settings }) {
    const draw = line()
        .x(
            (d) =>
                CalculateHitLocation(
                    { x: d.x, y: d.y },
                    settings.vizWidth,
                    settings.vizHeight
                ).x
        )
        .y(
            (d) =>
                CalculateHitLocation(
                    { x: d.x, y: d.y },
                    settings.vizWidth,
                    settings.vizHeight
                ).y
        )

    const angles = [
        { angle: -45, x: -233, y: 233, textx: -269, texty: 269, hide: true },
        { angle: -30, x: -184, y: 319, textx: -195, texty: 338 },
        { angle: -15, x: -102, y: 381, textx: -106, texty: 396 },
        { angle: 0, x: -1.5, y: 402, textx: 0, texty: 412 },
        { angle: 15, x: 101, y: 377, textx: 106, texty: 396 },
        { angle: 30, x: 183, y: 316, textx: 190, texty: 329 },
        { angle: 45, x: 226, y: 226, textx: 237, texty: 237, hide: true },
    ]

    const paths = []
    for (let i = 0; i < angles.length; i++) {
        const a = angles[i]
        paths.push(
            <>
                <path
                    d={draw([
                        { x: 0, y: 0 },
                        { x: a.x, y: a.y },
                    ])}
                    fill="none"
                    stroke="#c2c2c2"
                />
                <text
                    x={
                        CalculateHitLocation(
                            { x: a.textx, y: a.texty },
                            settings.vizWidth,
                            settings.vizHeight
                        ).x
                    }
                    y={
                        CalculateHitLocation(
                            { x: a.textx, y: a.texty },
                            settings.vizWidth,
                            settings.vizHeight
                        ).y
                    }
                    fill="#f00"
                >
                    {a.angle}°
                </text>
            </>
        )
    }

    return <g id="field-degrees">{paths}</g>
}
